import { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import styled from "styled-components"
import { nombreCliente } from "../../../constants/newContract"
import { formatDate } from "../../../helpers/date"
import Divider from "../../Divider"
import { InputNumber, InputSelect, InputText } from "../../form"
import { Button } from "../../ui"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { useLazyQuery } from "@apollo/client"
import { GET_WORD_CREATE } from "../../../services/siniestro"
import { useContract } from "../../../redux/contractReducer"
import { useSiniester } from "../../../redux/siniesterReducer"
import { formatNumber } from "../../../helpers/numbers"

const schema = yup.object().shape(
  {
    tipoCambio: yup.string().required(),
    beneficiario: yup.string().required("Este campo es obligatorio."),
    rfc: yup
      .string("Debe contener letras")
      .required("Este campo es obligatorio.")
      .matches(
        /^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))([A-Z\d]{3})?$/,
        "Por favor ingresa un RFC valido."
      ),
    cuenta: yup.string().when("cuenta", (val) => {
      if (val?.length > 0) {
        return yup
          .string()
          .matches(/^[0-9]+$/, "Deben ser solo números")
          .min(10, "Debe ser de 10 digitos")
          .max(10, "Debe ser de 10 digitos")
      } else {
        return yup.string().notRequired()
      }
    }),
    clabe: yup.string().when("clabe", (val) => {
      if (val?.length > 0) {
        return yup
          .string()
          .matches(/^[0-9]+$/, "Deben ser solo números")
          .min(18, "Debe ser de 18 digitos")
          .max(18, "Debe ser de 18 digitos")
      } else {
        return yup.string().notRequired()
      }
    }),
    iban: yup.string().when("iban", val => {
      if (val?.length > 0) {
        return yup
          .string().min(20, "Debe ser de mínimo 20 digitos").max(34, "Debe ser de máximo 34 digitos")
        } else {
          return yup.string().notRequired()
        }
    }),
    swiftAba: yup
      .string().when("swiftAba", val => {
        if (val?.length > 0) {
          return yup
            .string().min(8, "Debe ser de mínimo 8 digitos").max(11, "Debe ser de máximo 11 digitos")
          } else {
            return yup.string().notRequired()
          }
      }),
    cifNif: yup
      .string().when("cifNif", val => {
        if (val?.length > 0) {
          return yup
            .string().matches(/^[0-9]+$/, "Deben ser solo números").min(9, "Debe ser de 9 digitos").max(9, "Debe ser de 9 digitos")
          } else {
            return yup.string().notRequired()
          }
      })
  },
  [
    ["cuenta", "cuenta"],
    ["clabe", "clabe"],
    ["iban", "iban"],
    ["swiftAba", "swiftAba"],
    ["cifNif", "cifNif"]
  ]
)

const options = [
  { value: "mxn", label: "MXN" },
  { value: "usd", label: "USD" }
]
//directo, tercero
const tiposBeneficiario = [
  { value: "directo", label: "Directo" },
  { value: "tercero", label: "Tercero" }
]
//transferencia, cheque
const metodosPagos = [
  { value: "transferencia", label: "Transferencia" },
  { value: "cheque", label: "Cheque" }
]
export const ModalRegistroPago = ({ info = "", addPay, movimientos, currentMovement }) => {
  // FORM //
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset, 
    getValues,
    trigger
  } = useForm({ resolver: yupResolver(schema) })
  const { fecha, tipo, monto, moneda, pagos, estado } = info
  const {contractState} = useContract();
  const {siniesterState} = useSiniester();
  const [movements, setMovements] = useState([]);
  const [montoTemp, setMontoTemp] = useState(0);
  const [montoToDoc, setMontoToDoc] = useState(0);
  //eslint-disable-next-line
  const [documentName, setDocumentName] = useState("DocumentoPrueba.docx")
  const [movementsData, setMovementsData] = useState([]);
  const [monedaDefault, setMonedaDefault] = useState({
    value: "mxn",
    label: "MXN"
  })
  const [tipoBeneficiarioDefault, setTipoBeneficiarioDefault] = useState(
    tiposBeneficiario[0]
  )
  const [metodoPagoDefault, setMetodoPagoDefautl] = useState(metodosPagos[0])
  const onSubmit = (data) => {
    addPay(data)
  }

  const downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`
    const downloadLink = document.createElement("a")
    downloadLink.href = linkSource
    downloadLink.download = fileName
    downloadLink.click()
  }
  const [wordDocumentCreate] = useLazyQuery(GET_WORD_CREATE, {
    onCompleted({ wordDocumentCreate }) {
      if (wordDocumentCreate.statusCode === 200) {
        downloadBase64File(
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          wordDocumentCreate.response,
          documentName
        )
      }
    },
    onError(error) {
      console.log(error)
    }
  })
  useEffect(() => {
    if (currentMovement) {
      const slicedMovements = movimientos.slice(0, currentMovement + 1);
      setMovements(slicedMovements);
    }
  }, [currentMovement, movimientos])

  useEffect(() => {
    setMontoToDoc(movements[movements.length - 1]?.monto);
  }, [movements])
  useEffect(() => {
    calcMovements();
    //eslint-disable-next-line
  }, [montoToDoc])
  useEffect(() => {
    setMontoTemp(
      pagos?.Monto === "0" || pagos?.Monto === "0.00" ? monto : pagos?.Monto
    )
    pagos.tipoPago = tipo
    reset(pagos)
    setMonedaDefault(
      options.find((c) => c.id || c.value === pagos?.moneda?.value)?.value ||
        pagos?.moneda ||
        options[0].value
    )
    setTipoBeneficiarioDefault(
      tiposBeneficiario.find(
        (c) => c.id || c.value === pagos?.tipoBeneficiario?.value
      )?.value ||
        pagos?.tipoBeneficiario ||
        tiposBeneficiario[0].value
    )
    setMetodoPagoDefautl(
      metodosPagos.find((c) => c.id || c.value === pagos?.metodoPagos?.value)
        ?.value ||
        pagos?.metodoPagos ||
        metodosPagos[0].value
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [info, info?.pagos?.Monto])
  useEffect(() => {
    reset({ ...pagos, Monto: montoTemp })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [montoTemp])
  useEffect(() => {
    calcMovements();
    //eslint-disable-next-line
  }, [ movements])
  const handleWord = async () => {
    const { ajustador, expero, siniestro_id, fecha } = siniesterState;
    const values = getValues();
    const output = await trigger();
    if (!output) return;
    const { cuenta, clabe, iban, swiftAba, cifNif, banco, Monto, moneda, beneficiario } = values;
    const variables = { input : {
      company: "",
      original_insured: contractState?.nombre || "",
      adjuster_expert: `${ajustador || ""} ${ajustador && expero ? "/" : ""} ${expero || ""}` || "",
      validity_period: `${formatDate(contractState?.fecha_ini)} - ${formatDate(contractState?.fecha_fin)}` || "",
      lob: contractState?.valor_ramo || "",
      share: `${contractState?.porcentaje}%` || "",
      claim_number: `#${siniestro_id}` || "",
      date_of_loss: formatDate(fecha),
      contract_currency: contractState?.valor_moneda || "",
      payment_currency: `${(moneda?.label || moneda || "").toUpperCase()}`,
      type_movement: tipo === "Anticipo" || tipo === "Indemnización" ? "LOSS" 
                   : tipo === "Pago expertos" || tipo === "Pago ajustadores" ? "FEES & EXPENSES" 
                   : tipo,
      amount_movement: `${formatNumber(Monto)}`,
      beneficiary: `${beneficiario || ""}`,
      amount_reserve: `${movementsData?.reserva || "0.00"}`,
      amount_loss: `${movementsData?.loss || ""}`,
      amount_deductible: `${movementsData?.deductible || "0.00"}`,
      amount_fees: `${movementsData?.proveedores || "0.00"}`,
      amount_salvages: `${movementsData?.salvamento || "0.00"}`,
      amount_recovery: `${movementsData?.recuperacion || "0.00"}`,	
      amount_total: `${formatNumber(Monto)}`,
      date_roe: "",
      account: cuenta,
      clabe: clabe,
      bank: banco,
      iban: iban,
      swift: swiftAba,
      cif: cifNif
    }}
    wordDocumentCreate({ variables: variables })
  }
  const calcMovements = () => {
    let reserva = 0;
    let siniestro = 0;
    let proveedores = 0;
    //eslint-disable-next-line
    let salvamento = 0;
    let mxn = 0;
    let usd = 0;
    let loss = 0;
    let deductible = 0;
    let nextTo0 = false;
    movements?.forEach((item, index) => {
      if (nextTo0) {
        loss = 0;
        deductible = 0;
        proveedores = 0;
        salvamento  = 0;
        nextTo0 = false;
      }
      const amount = (index === currentMovement) ? 
        Number(montoToDoc?.split(",")?.join(""))  :
        Number(item.monto.split(",").join(""));
      switch (item.tipo) {
        case "Recuperaciones":
          item.moneda === "usd"
            ? (usd += Number(amount))
            : (mxn += Number(amount));
          break;

        case "Deducible":
        case "Coaseguro":
          reserva -= Number(amount);
          deductible += Number(amount);
          loss += Number(amount);
          break;

        case "Anticipo":
        case "Indemnización":
          nextTo0 = true;
          reserva -= Number(amount);
          siniestro += Number(amount);
          loss += Number(amount);
          break;

        case "Salvamento":
          salvamento += Number(amount);
          break;

        case "Pago ajustadores":
        case "Pago expertos":
          nextTo0 = true;
          proveedores += Number(amount);
          break;

        case "Alta reserva":
        case "Incremento reserva":
        case "Disminución reserva":
          reserva = Number(amount);
          siniestro = 0;
          proveedores = 0;
          salvamento = 0;
          loss = 0;
          deductible = 0;
          mxn = 0;
          usd = 0;
          break;
        default:
          break;
      }
    });
    setMovementsData({
      reserva: formatNumber(reserva),
      siniestro: formatNumber(siniestro),
      proveedores: formatNumber(proveedores),
      salvamento: formatNumber(0),
      mxn: formatNumber(mxn),
      usd: formatNumber(usd),
      recuperacion: formatNumber(0),
      loss: formatNumber(loss),
      deductible: formatNumber(deductible),
    });
  };
  return (
    <Container>
      <Property>{formatDate(fecha)}</Property>
      <Property>Tipo de Movimiento: {tipo}</Property>
      <Property>
        Monto del Movimiento: ${formatNumber(monto)} {moneda?.toUpperCase()}
      </Property>
      <Divider />
      <SubTitle>Solicitud de pago</SubTitle>
      <FormContainer onSubmit={handleSubmit(onSubmit)}>
        <InputRow>
          <InputNumber
            label="Monto"
            name="Monto"
            type="number"
            prefix={"$"}
            control={control}
            placeholder="Monto"
            readOnly={tipo === "Indemnización"}
            register={{ ...register("Monto" , {
              onChange: (e) => {setMontoToDoc(e?.target?.value)},
            })}}
            errorMessage={errors.Monto?.type}
          />
          <InputSelect
            label="Moneda"
            name="moneda"
            options={options}
            control={control}
            setDefaultValue={setMonedaDefault}
            defaultValue={monedaDefault}
            errorMessage={errors.moneda?.type}
            placeholder="Moneda"
            required={true}
          />
          <InputText
            label="Tipo de pago"
            name="tipoPago"
            control={control}
            placeholder="tipoPago"
            register={{ ...register("tipoPago") }}
            errorMessage={errors.tipoPago?.type}
            readOnly={true}
          />
          <InputText
            label="Beneficiario"
            name="beneficiario"
            control={control}
            register={{ ...register("beneficiario") }}
            errorMessage={errors.beneficiario?.type}
            placeholder="Beneficiario"
          />
        </InputRow>
        <InputRow>
          <InputSelect
            label="Tipo de beneficiario"
            name="tipoBeneficiario"
            options={tiposBeneficiario}
            defaultValue={tipoBeneficiarioDefault}
            setDefaultValue={setTipoBeneficiarioDefault}
            control={control}
            errorMessage={errors.tipoPago?.type}
            placeholder="Tipo de beneficiario"
            required={true}
          />
          <InputNumber
            label="Tipo de cambio"
            name="tipoCambio"
            type="number"
            thousandSeparator=""
            options={nombreCliente}
            control={control}
            register={{ ...register("tipoCambio") }}
            errorMessage={errors.tipoCambio?.type}
            placeholder="Tipo de cambio"
            // mwidth={"240px"}
          />
          <InputSelect
            label="Método de pago"
            name="metodoPagos"
            options={metodosPagos}
            defaultValue={metodoPagoDefault}
            setDefaultValue={setMetodoPagoDefautl}
            control={control}
            value={true}
            errorMessage={errors.tipoPago?.type}
            placeholder="Tipo de pago"
          />
          <InputText
            required={false}
            label="RFC"
            name="rfc"
            type="text"
            control={control}
            placeholder="RFC"
            register={{ ...register("rfc") }}
            errorMessage={
              errors.rfc?.message ? errors.rfc?.message : errors.rfc?.type
            }
            // mwidth={"240px"}
          />
        </InputRow>
        {/* DATOS BANCARIOS */}
        <SubTitle>Datos Bancarios</SubTitle>
        <InputRow>
          <InputText
            required={false}
            label="Cuenta"
            name="cuenta"
            type="number"
            control={control}
            placeholder="Cuenta"
            register={{ ...register("cuenta") }}
            errorMessage={
              errors.cuenta?.message
                ? errors.cuenta?.message
                : errors.cuenta?.type
            }
          />
          <InputText
            required={false}
            // mwidth={"240px"}
            label="Clabe"
            name="clabe"
            type="text"
            control={control}
            placeholder="Clabe"
            register={{ ...register("clabe") }}
            errorMessage={
              errors.clabe?.message ? errors.clabe?.message : errors.clabe?.type
            }
          />
          <InputText
            required={false}
            // mwidth={"240px"}
            label="Banco"
            name="banco"
            type="text"
            control={control}
            placeholder="Banco"
            register={{ ...register("banco") }}
            errorMessage={errors.banco?.type}
          />
          <InputText
            required={false}
            // mwidth={"240px"}
            label="IBAN"
            name="iban"
            type="text"
            control={control}
            placeholder="IBAN"
            register={{ ...register("iban") }}
            errorMessage={
              errors.iban?.message ? errors.iban?.message : errors.iban?.type
            }
          />
        </InputRow>
        <InputRow>
          <InputText
            required={false}
            label="Swift Aba"
            name="swiftAba"
            type="text"
            control={control}
            placeholder="Swift Aba"
            register={{ ...register("swiftAba") }}
            errorMessage={
              errors.swiftAba?.message
                ? errors.swiftAba?.message
                : errors.swiftAba?.type
            }
          />
          <InputText
            required={false}
            // mwidth={"240px"}
            label="CIF/NIF"
            name="cifNif"
            type="text"
            control={control}
            placeholder="CIF/NIF"
            register={{ ...register("cifNif") }}
            errorMessage={
              errors.cifNif?.message
                ? errors.cifNif?.message
                : errors.cifNif?.type
            }
          />
        </InputRow>
        <ButtonContainer>
          <Button
            outlined
            text={"Generar Word"}
            type="button"
            onClick={handleWord}
            style={{ padding: "8px 24px", fontSize: "14px" }}
          />
          {estado !== "pagado" && (
            <Button
              text={"Guardar"}
              type="submit"
              style={{ padding: "8px 24px", fontSize: "14px" }}
            />
          )}
        </ButtonContainer>
      </FormContainer>
    </Container>
  )
}

const Container = styled.div`
  & input {
    width: 100%;
  }
`

const FormContainer = styled.form``

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 10px;
`

const InputRow = styled.div`
  /* display: flex;
  gap: 20px;
  margin-bottom: 10px; */
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }
  @media only screen and (max-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
  @media only screen and (max-width: 425px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 24px;
  }
`

const Property = styled.h2`
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
`

const SubTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: var(--primary-royal-blue);
  margin: 35px 0;
`
